export default __webpack_public_path__ + "static/media/Screenshot (1082).4f714ab3.png";